module.exports = __webpack_public_path__ + "img/111.7406ba48.png";